/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_Ask_AdminInputs */

const cs_ebr_conn_ask_admin = /** @type {(inputs: Ebr_Conn_Ask_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBránu připojuje administrátor kanceláře.`)
};

const en_ebr_conn_ask_admin = /** @type {(inputs: Ebr_Conn_Ask_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An office admin connects eBrána.`)
};

/**
* | output |
* | --- |
* | "An office admin connects eBrána." |
*
* @param {Ebr_Conn_Ask_AdminInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_ask_admin = /** @type {((inputs?: Ebr_Conn_Ask_AdminInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Ask_AdminInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_ask_admin(inputs)
	return cs_ebr_conn_ask_admin(inputs)
});